export default [
  {
    id: 0,
    name: "이수진",
    image: "/images/back1.png",
    detail: "이수진",
    vote: 8,
  },
  {
    id: 1,
    name: "서수경",
    image: "/images/back2.png",
    detail: "서수경",
    vote: 7,
  },
  {
    id: 2,
    name: "박경준",
    image: "/images/back3.png",
    detail: "박경준",
    vote: 5,
  },
  {
    id: 3,
    name: "한혜원",
    image: "/images/back4.png",
    detail: "한혜원",
    vote: 4,
  },
  {
    id: 4,
    name: "권민아",
    image: "/images/back5.png",
    detail: "권민아",
    vote: 3,
  },
  {
    id: 5,
    name: "정환우",
    image: "/images/back6.png",
    detail: "정환우",
    vote: 3,
  },
  {
    id: 6,
    name: "김승우",
    image: "/images/back7.png",
    detail: "김승우",
    vote: 3,
  },
  {
    id: 7,
    name: "김윤지",
    image: "/images/back8.png",
    detail: "김윤지",
    vote: 2,
  },
  {
    id: 8,
    name: "유준환",
    image: "/images/back9.png",
    detail: "유준환",
    vote: 1,
  },
  {
    id: 9,
    name: "김채리",
    image: "/images/back10.png",
    detail: "김채리",
    vote: 0,
  },
];
